<template>
  <CCard>
    <CImage
      class="rounded-1 w-full justify-center"
      :height="135"
      :img-props="{
        draggable: false,
        style: { border: `1px solid ${themeVars.primary5}`, borderRadius: '4px', 'max-width': '100%' },
      }"
      lazy
      preview-disabled
      :src="option.imageUrl"
    />

    <div class="color-text font-bold font-size-4">{{ option.label }}</div>
  </CCard>
</template>

<script lang="ts" setup>
import { type SelectOption } from 'naive-ui'
import CCard from '@lib/components/CCard/CCard.vue'
import CImage from '@lib/components/CImage/CImage.vue'
import useThemeVars from '@lib/composables/useThemeVars'

defineProps<{
  option: SelectOption & { index: number; imageUrl: string; name?: string }
}>()

const themeVars = useThemeVars()
</script>
